import React from 'react';
import { Link } from 'react-router-dom';
import dateFormat from "dateformat";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SingleItem = ({ index, data, handleDelete, paginateData, HandleTimeFun }) => {
    return (
        <>
          <tr>
            <td data-label="S.N.">{(parseFloat(index + 1 ) + ( parseFloat(paginateData?.page ) * parseFloat(paginateData?.limit ) )  ) - 10}</td>
                <td data-label="Mining Type">
                    {
                    data?.mining_type === "bitcoin"
                    ?
                    <span className="badge bg-primary">Bitcoin Mining</span>
                   
                    :
                    <span className="badge bg-success">Gold Mining</span>
                    }
                </td>
                
                <td data-label="Promotion Name">
                    {data?.promotion_name}
                </td>
                
                <td data-label="Period">
                    {data?.period} {data?.period_type}
                </td>
                
                <td data-label="Profit">
                    {data?.percentage}%
                </td>
                
                <td data-label="Expired Time">
                {dateFormat(data?.expired_time, "d-m-yyyy")}
                </td>
                
                <td data-label="Created">
                {dateFormat(data?.createdAt, "d-m-yyyy h:MM:ss TT")}
                </td>
                <td data-label="Action">
                          
                    <button onClick={() => HandleTimeFun(data._id)} className="btn btn-sm btn-outline-success me-1 confirmationBtn"
                    >
                       <FontAwesomeIcon icon="fa-regular fa-calendar-plus" />
                    </button>


                    <Link to={`/admin/mining/edit/${data._id}`} className="btn btn-sm btn-outline-primary editBtn"
                    >
                        <i className="la la-pencil"></i>Edit
                    </Link>
                    <button onClick={() => handleDelete(data._id)} className="btn btn-sm btn-outline-danger ms-1 confirmationBtn"
                    >
                       <FontAwesomeIcon icon="fa-solid fa-trash-can" />Delete
                    </button>
              

                </td>
            </tr>  
        </>
    );
};

export default SingleItem;